var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h22v22H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.413 13.64c.108.278.179.569.21.864.04.265.069.533.09.8l.006.074v.037c0 .718-.58 1.3-1.298 1.3H6.578a1.299 1.299 0 0 1-1.298-1.3v-.037l.006-.078c.022-.266.053-.534.089-.8.033-.294.104-.584.212-.86.4-.87 3.339-2.125 5.413-2.125 2.074 0 5.013 1.255 5.413 2.125M11 10.687a2.701 2.701 0 1 1 0-5.402 2.701 2.701 0 0 1 0 5.402"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11 0C4.925 0 0 4.926 0 11c0 6.075 4.925 11 11 11s11-4.925 11-11c0-6.074-4.925-11-11-11m0 1.56c5.206 0 9.44 4.235 9.44 9.44 0 5.205-4.234 9.441-9.44 9.441-5.206 0-9.44-4.236-9.44-9.441 0-5.205 4.234-9.44 9.44-9.44",
    mask: "url(#b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b340fe2a88633d562bfe0004348b59b1.svg";
export { ForwardRef as ReactComponent };